import {
  ORDENDIGITAL_ERROR,
  ORDENDIGITAL_LOADING,
  ORDENDIGITAL_SUCCESS,
  ORDENDIGITAL_RESET,
  ORDENDIGITAL_ALTATURNO_SET,
  ORDENDIGITAL_SOLICITANTE_SET,
  ORDENDIGITAL_LOAD,
  ORDENDIGITAL_FLGVOLVER,
  ORDENDIGITALGRUPO_SUCCESS,
  RESET_PORTAL_CONTEXT,
  ORDENDIGITALPDF_SUCCESS,
  ORDENDIGITALPDF_LOADING,
  ORDENDIGITALPDF_ERROR,
  ORDENDIGITALPDF_RESET,
} from "../ActionTypes";
import ordenDigitalInitialState from "../initialStates/ordenDigitalInitialState";

const ordenDigital = (state, { payload, type }) => {
  switch (type) {
    case ORDENDIGITAL_LOADING:
      return {
        ...state,
        ordenDigital: {
          ...state.ordenDigital,
          error: null,
          loading: true,
        },
      };
    case ORDENDIGITAL_LOAD:
      return {
        ...state,
        ordenDigital: {
          ...state.ordenDigital,
          load: payload,
        },
      };
    case ORDENDIGITAL_SUCCESS:
      return {
        ...state,
        ordenDigital: {
          ...state.ordenDigital,
          loading: false,
          error: null,
          data: payload,
        },
      };
    case ORDENDIGITALPDF_SUCCESS:
      return {
        ...state,
        ordenDigital: {
          ...state.ordenDigital,
          loadPdf: false,
          error: null,
          pdf: payload,
        },
      };
    case ORDENDIGITALPDF_LOADING:
      return {
        ...state,
        ordenDigital: {
          ...state.ordenDigital,
          error: null,
          loadPdf: true,
        },
      };
    case ORDENDIGITALPDF_ERROR:
      return {
        ...state,
        ordenDigital: {
          ...state.ordenDigital,
          error: payload,
          loadPdf: false,
        },
      };
    case ORDENDIGITAL_ALTATURNO_SET:
      return {
        ...state,
        ordenDigital: {
          ...state.ordenDigital,
          loading: false,
          error: null,
          altaTurno: payload,
        },
      };
    case ORDENDIGITAL_SOLICITANTE_SET:
      return {
        ...state,
        ordenDigital: {
          ...state.ordenDigital,
          loading: false,
          error: null,
          idMedSolicitante: payload,
        },
      };
    case ORDENDIGITAL_FLGVOLVER:
      return {
        ...state,
        ordenDigital: {
          ...state.ordenDigital,
          flgVolver: payload,
        },
      };
    case ORDENDIGITAL_ERROR:
      return {
        ...state,
        ordenDigital: {
          ...state.ordenDigital,
          error: payload,
          loading: false,
        },
      };
    case ORDENDIGITALPDF_RESET:
      return {
        ...state,
        ordenDigital: {
          ...state.ordenDigital,
          error: null,
          loadPdf: false,
          pdf: null,
        },
      };

    case ORDENDIGITAL_RESET:
      return {
        ...state,
        ordenDigital: {
          ...state.ordenDigital,
          loading: false,
          error: null,
          data: null,
          altaTurno: null,
          grupoMed: null,
          idMedSolicitante: null,
          load: false,
          pdf: null,
          flgVolver: false,
        },
      };
    case ORDENDIGITALGRUPO_SUCCESS:
      return {
        ...state,
        ordenDigital: {
          ...state.ordenDigital,
          loading: false,
          error: null,
          grupoMed: payload,
        },
      };
    case RESET_PORTAL_CONTEXT:
      return ordenDigitalInitialState;

    default:
      return state;
  }
};

export default ordenDigital;
